// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document_batch.ml",
      151,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "DocumentBatchStats"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "DocumentBatchOwnerStats"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentBatch"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "$$Document"
        ]]
    });

const $$Document = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document_batch.ml",
      265,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentBatchStats"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentBatchOwnerStats"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentBatch"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document_batch.ml",
      377,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentBatchStats"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentBatchOwnerStats"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentBatch"
        ]]
    });

const DocumentBatch = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document_batch.ml",
      487,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentBatchStats"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentBatchOwnerStats"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DocumentBatchStats = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document_batch.ml",
      524,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DocumentBatchOwnerStats = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_document_batch.ml",
      608,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.document.v1alpha1.DocumentBatch.DocumentBatchStats";
}

function make(total_countOpt, sign_required_countOpt, signed_countOpt, sender_sign_required_countOpt, sender_signed_countOpt, recipient_sign_required_countOpt, recipient_signed_countOpt, param) {
  const total_count = total_countOpt !== undefined ? total_countOpt : 0;
  const sign_required_count = sign_required_countOpt !== undefined ? sign_required_countOpt : 0;
  const signed_count = signed_countOpt !== undefined ? signed_countOpt : 0;
  const sender_sign_required_count = sender_sign_required_countOpt !== undefined ? sender_sign_required_countOpt : 0;
  const sender_signed_count = sender_signed_countOpt !== undefined ? sender_signed_countOpt : 0;
  const recipient_sign_required_count = recipient_sign_required_countOpt !== undefined ? recipient_sign_required_countOpt : 0;
  const recipient_signed_count = recipient_signed_countOpt !== undefined ? recipient_signed_countOpt : 0;
  return {
          total_count: total_count,
          sign_required_count: sign_required_count,
          signed_count: signed_count,
          sender_sign_required_count: sender_sign_required_count,
          sender_signed_count: sender_signed_count,
          recipient_sign_required_count: recipient_sign_required_count,
          recipient_signed_count: recipient_signed_count
        };
}

const merge_total_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "total_count",
            "totalCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_sign_required_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "sign_required_count",
            "signRequiredCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_signed_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "signed_count",
            "signedCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_sender_sign_required_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "sender_sign_required_count",
            "senderSignRequiredCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_sender_signed_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "sender_signed_count",
            "senderSignedCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_recipient_sign_required_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            15,
            "recipient_sign_required_count",
            "recipientSignRequiredCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_recipient_signed_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "recipient_signed_count",
            "recipientSignedCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

function merge(t1, t2) {
  return {
          total_count: Curry._2(merge_total_count, t1.total_count, t2.total_count),
          sign_required_count: Curry._2(merge_sign_required_count, t1.sign_required_count, t2.sign_required_count),
          signed_count: Curry._2(merge_signed_count, t1.signed_count, t2.signed_count),
          sender_sign_required_count: Curry._2(merge_sender_sign_required_count, t1.sender_sign_required_count, t2.sender_sign_required_count),
          sender_signed_count: Curry._2(merge_sender_signed_count, t1.sender_signed_count, t2.sender_signed_count),
          recipient_sign_required_count: Curry._2(merge_recipient_sign_required_count, t1.recipient_sign_required_count, t2.recipient_sign_required_count),
          recipient_signed_count: Curry._2(merge_recipient_signed_count, t1.recipient_signed_count, t2.recipient_signed_count)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "total_count",
                    "totalCount"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "sign_required_count",
                        "signRequiredCount"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "signed_count",
                            "signedCount"
                          ],
                          Ocaml_protoc_plugin__Spec.int32_int,
                          0
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                10,
                                "sender_sign_required_count",
                                "senderSignRequiredCount"
                              ],
                              Ocaml_protoc_plugin__Spec.int32_int,
                              0
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    11,
                                    "sender_signed_count",
                                    "senderSignedCount"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int32_int,
                                  0
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        15,
                                        "recipient_sign_required_count",
                                        "recipientSignRequiredCount"
                                      ],
                                      Ocaml_protoc_plugin__Spec.int32_int,
                                      0
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            16,
                                            "recipient_signed_count",
                                            "recipientSignedCount"
                                          ],
                                          Ocaml_protoc_plugin__Spec.int32_int,
                                          0
                                        ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._8(serialize, writer, param.total_count, param.sign_required_count, param.signed_count, param.sender_sign_required_count, param.sender_signed_count, param.recipient_sign_required_count, param.recipient_signed_count);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(total_count, sign_required_count, signed_count, sender_sign_required_count, sender_signed_count, recipient_sign_required_count, recipient_signed_count) {
  return {
          total_count: total_count,
          sign_required_count: sign_required_count,
          signed_count: signed_count,
          sender_sign_required_count: sender_sign_required_count,
          sender_signed_count: sender_signed_count,
          recipient_sign_required_count: recipient_sign_required_count,
          recipient_signed_count: recipient_signed_count
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DocumentBatch.DocumentBatchStats", spec(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.total_count, param.sign_required_count, param.signed_count, param.sender_sign_required_count, param.sender_signed_count, param.recipient_sign_required_count, param.recipient_signed_count);
  };
}

function constructor$1(total_count, sign_required_count, signed_count, sender_sign_required_count, sender_signed_count, recipient_sign_required_count, recipient_signed_count) {
  return {
          total_count: total_count,
          sign_required_count: sign_required_count,
          signed_count: signed_count,
          sender_sign_required_count: sender_sign_required_count,
          sender_signed_count: sender_signed_count,
          recipient_sign_required_count: recipient_sign_required_count,
          recipient_signed_count: recipient_signed_count
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DocumentBatch.DocumentBatchStats", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DocumentBatchStats, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.document.v1alpha1.DocumentBatch.DocumentBatchOwnerStats";
}

function make$1(total_countOpt, sign_required_countOpt, signed_countOpt, sender_sign_required_countOpt, sender_signed_countOpt, recipient_sign_required_countOpt, recipient_signed_countOpt, param) {
  const total_count = total_countOpt !== undefined ? total_countOpt : 0;
  const sign_required_count = sign_required_countOpt !== undefined ? sign_required_countOpt : 0;
  const signed_count = signed_countOpt !== undefined ? signed_countOpt : 0;
  const sender_sign_required_count = sender_sign_required_countOpt !== undefined ? sender_sign_required_countOpt : 0;
  const sender_signed_count = sender_signed_countOpt !== undefined ? sender_signed_countOpt : 0;
  const recipient_sign_required_count = recipient_sign_required_countOpt !== undefined ? recipient_sign_required_countOpt : 0;
  const recipient_signed_count = recipient_signed_countOpt !== undefined ? recipient_signed_countOpt : 0;
  return {
          total_count: total_count,
          sign_required_count: sign_required_count,
          signed_count: signed_count,
          sender_sign_required_count: sender_sign_required_count,
          sender_signed_count: sender_signed_count,
          recipient_sign_required_count: recipient_sign_required_count,
          recipient_signed_count: recipient_signed_count
        };
}

const merge_total_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "total_count",
            "totalCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_sign_required_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "sign_required_count",
            "signRequiredCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_signed_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "signed_count",
            "signedCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_sender_sign_required_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "sender_sign_required_count",
            "senderSignRequiredCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_sender_signed_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "sender_signed_count",
            "senderSignedCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_recipient_sign_required_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            15,
            "recipient_sign_required_count",
            "recipientSignRequiredCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_recipient_signed_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "recipient_signed_count",
            "recipientSignedCount"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

function merge$1(t1, t2) {
  return {
          total_count: Curry._2(merge_total_count$1, t1.total_count, t2.total_count),
          sign_required_count: Curry._2(merge_sign_required_count$1, t1.sign_required_count, t2.sign_required_count),
          signed_count: Curry._2(merge_signed_count$1, t1.signed_count, t2.signed_count),
          sender_sign_required_count: Curry._2(merge_sender_sign_required_count$1, t1.sender_sign_required_count, t2.sender_sign_required_count),
          sender_signed_count: Curry._2(merge_sender_signed_count$1, t1.sender_signed_count, t2.sender_signed_count),
          recipient_sign_required_count: Curry._2(merge_recipient_sign_required_count$1, t1.recipient_sign_required_count, t2.recipient_sign_required_count),
          recipient_signed_count: Curry._2(merge_recipient_signed_count$1, t1.recipient_signed_count, t2.recipient_signed_count)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "total_count",
                    "totalCount"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "sign_required_count",
                        "signRequiredCount"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "signed_count",
                            "signedCount"
                          ],
                          Ocaml_protoc_plugin__Spec.int32_int,
                          0
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                10,
                                "sender_sign_required_count",
                                "senderSignRequiredCount"
                              ],
                              Ocaml_protoc_plugin__Spec.int32_int,
                              0
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    11,
                                    "sender_signed_count",
                                    "senderSignedCount"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int32_int,
                                  0
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        15,
                                        "recipient_sign_required_count",
                                        "recipientSignRequiredCount"
                                      ],
                                      Ocaml_protoc_plugin__Spec.int32_int,
                                      0
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            16,
                                            "recipient_signed_count",
                                            "recipientSignedCount"
                                          ],
                                          Ocaml_protoc_plugin__Spec.int32_int,
                                          0
                                        ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._8(serialize$1, writer, param.total_count, param.sign_required_count, param.signed_count, param.sender_sign_required_count, param.sender_signed_count, param.recipient_sign_required_count, param.recipient_signed_count);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(total_count, sign_required_count, signed_count, sender_sign_required_count, sender_signed_count, recipient_sign_required_count, recipient_signed_count) {
  return {
          total_count: total_count,
          sign_required_count: sign_required_count,
          signed_count: signed_count,
          sender_sign_required_count: sender_sign_required_count,
          sender_signed_count: sender_signed_count,
          recipient_sign_required_count: recipient_sign_required_count,
          recipient_signed_count: recipient_signed_count
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DocumentBatch.DocumentBatchOwnerStats", spec$1(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.total_count, param.sign_required_count, param.signed_count, param.sender_sign_required_count, param.sender_signed_count, param.recipient_sign_required_count, param.recipient_signed_count);
  };
}

function constructor$3(total_count, sign_required_count, signed_count, sender_sign_required_count, sender_signed_count, recipient_sign_required_count, recipient_signed_count) {
  return {
          total_count: total_count,
          sign_required_count: sign_required_count,
          signed_count: signed_count,
          sender_sign_required_count: sender_sign_required_count,
          sender_signed_count: sender_signed_count,
          recipient_sign_required_count: recipient_sign_required_count,
          recipient_signed_count: recipient_signed_count
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DocumentBatch.DocumentBatchOwnerStats", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DocumentBatchOwnerStats, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.document.v1alpha1.DocumentBatch";
}

function make$2(id, codeOpt, tinOpt, stateOpt, project_idOpt, stats, owner_stats, create_time, update_time, param) {
  const code = codeOpt !== undefined ? codeOpt : "";
  const tin = tinOpt !== undefined ? tinOpt : "";
  const state = stateOpt !== undefined ? stateOpt : "";
  const project_id = project_idOpt !== undefined ? project_idOpt : "";
  return {
          id: id,
          code: code,
          tin: tin,
          state: state,
          project_id: project_id,
          stats: stats,
          owner_stats: owner_stats,
          create_time: create_time,
          update_time: update_time
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "code",
            "code"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "state",
            "state"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_project_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "project_id",
            "projectId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_stats = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            25,
            "stats",
            "stats"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: DocumentBatchStats.name,
                make: DocumentBatchStats.make,
                from_proto: DocumentBatchStats.from_proto,
                from_proto_exn: DocumentBatchStats.from_proto_exn,
                to_proto: DocumentBatchStats.to_proto,
                to_proto$p: DocumentBatchStats.to_proto$p,
                merge: DocumentBatchStats.merge,
                to_json: DocumentBatchStats.to_json,
                from_json_exn: DocumentBatchStats.from_json_exn,
                from_json: DocumentBatchStats.from_json
              })
        ]));

const merge_owner_stats = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            26,
            "owner_stats",
            "ownerStats"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: DocumentBatchOwnerStats.name,
                make: DocumentBatchOwnerStats.make,
                from_proto: DocumentBatchOwnerStats.from_proto,
                from_proto_exn: DocumentBatchOwnerStats.from_proto_exn,
                to_proto: DocumentBatchOwnerStats.to_proto,
                to_proto$p: DocumentBatchOwnerStats.to_proto$p,
                merge: DocumentBatchOwnerStats.merge,
                to_json: DocumentBatchOwnerStats.to_json,
                from_json_exn: DocumentBatchOwnerStats.from_json_exn,
                from_json: DocumentBatchOwnerStats.from_json
              })
        ]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            31,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_update_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            32,
            "update_time",
            "updateTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          code: Curry._2(merge_code, t1.code, t2.code),
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          state: Curry._2(merge_state, t1.state, t2.state),
          project_id: Curry._2(merge_project_id, t1.project_id, t2.project_id),
          stats: Curry._2(merge_stats, t1.stats, t2.stats),
          owner_stats: Curry._2(merge_owner_stats, t1.owner_stats, t2.owner_stats),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
          update_time: Curry._2(merge_update_time, t1.update_time, t2.update_time)
        };
}

function spec$2(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "code",
                        "code"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "tin",
                            "tin"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "state",
                                "state"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "project_id",
                                    "projectId"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        25,
                                        "stats",
                                        "stats"
                                      ],
                                      Ocaml_protoc_plugin__Spec.message({
                                            name: DocumentBatchStats.name,
                                            make: DocumentBatchStats.make,
                                            from_proto: DocumentBatchStats.from_proto,
                                            from_proto_exn: DocumentBatchStats.from_proto_exn,
                                            to_proto: DocumentBatchStats.to_proto,
                                            to_proto$p: DocumentBatchStats.to_proto$p,
                                            merge: DocumentBatchStats.merge,
                                            to_json: DocumentBatchStats.to_json,
                                            from_json_exn: DocumentBatchStats.from_json_exn,
                                            from_json: DocumentBatchStats.from_json
                                          })
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            26,
                                            "owner_stats",
                                            "ownerStats"
                                          ],
                                          Ocaml_protoc_plugin__Spec.message({
                                                name: DocumentBatchOwnerStats.name,
                                                make: DocumentBatchOwnerStats.make,
                                                from_proto: DocumentBatchOwnerStats.from_proto,
                                                from_proto_exn: DocumentBatchOwnerStats.from_proto_exn,
                                                to_proto: DocumentBatchOwnerStats.to_proto,
                                                to_proto$p: DocumentBatchOwnerStats.to_proto$p,
                                                merge: DocumentBatchOwnerStats.merge,
                                                to_json: DocumentBatchOwnerStats.to_json,
                                                from_json_exn: DocumentBatchOwnerStats.from_json_exn,
                                                from_json: DocumentBatchOwnerStats.from_json
                                              })
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                31,
                                                "create_time",
                                                "createTime"
                                              ],
                                              Ocaml_protoc_plugin__Spec.message({
                                                    name: $$let.name,
                                                    make: $$let.make,
                                                    from_proto: $$let.from_proto,
                                                    from_proto_exn: $$let.from_proto_exn,
                                                    to_proto: $$let.to_proto,
                                                    to_proto$p: $$let.to_proto$p,
                                                    merge: $$let.merge,
                                                    to_json: $$let.to_json,
                                                    from_json_exn: $$let.from_json_exn,
                                                    from_json: $$let.from_json
                                                  })
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                  [
                                                    32,
                                                    "update_time",
                                                    "updateTime"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.message({
                                                        name: $$let$1.name,
                                                        make: $$let$1.make,
                                                        from_proto: $$let$1.from_proto,
                                                        from_proto_exn: $$let$1.from_proto_exn,
                                                        to_proto: $$let$1.to_proto,
                                                        to_proto$p: $$let$1.to_proto$p,
                                                        merge: $$let$1.merge,
                                                        to_json: $$let$1.to_json,
                                                        from_json_exn: $$let$1.from_json_exn,
                                                        from_json: $$let$1.from_json
                                                      })
                                                ]), Ocaml_protoc_plugin__Spec.nil)))))))));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry.app(serialize$2, [
        writer,
        param.id,
        param.code,
        param.tin,
        param.state,
        param.project_id,
        param.stats,
        param.owner_stats,
        param.create_time,
        param.update_time
      ]);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(id, code, tin, state, project_id, stats, owner_stats, create_time, update_time) {
  return {
          id: id,
          code: code,
          tin: tin,
          state: state,
          project_id: project_id,
          stats: stats,
          owner_stats: owner_stats,
          create_time: create_time,
          update_time: update_time
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DocumentBatch", spec$2(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.code,
                param.tin,
                param.state,
                param.project_id,
                param.stats,
                param.owner_stats,
                param.create_time,
                param.update_time
              ]);
  };
}

function constructor$5(id, code, tin, state, project_id, stats, owner_stats, create_time, update_time) {
  return {
          id: id,
          code: code,
          tin: tin,
          state: state,
          project_id: project_id,
          stats: stats,
          owner_stats: owner_stats,
          create_time: create_time,
          update_time: update_time
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DocumentBatch", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentBatchStats"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentBatchOwnerStats"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DocumentBatch, {
      DocumentBatchStats: DocumentBatchStats,
      DocumentBatchOwnerStats: DocumentBatchOwnerStats,
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentBatchStats"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentBatchOwnerStats"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "DocumentBatch"
        ]]
    }, V1alpha1, {
      DocumentBatch: DocumentBatch
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentBatchStats"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentBatchOwnerStats"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "DocumentBatch"
              ]]
          },
          "V1alpha1"
        ]]
    }, $$Document, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "DocumentBatchStats"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "DocumentBatchOwnerStats"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "DocumentBatch"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "$$Document"
        ]]
    }, Buhta, {
      $$Document: $$Document
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
